import { ApiError } from '../api/client'

/**
 * Verständlicher Text für einen fehlgeschlagenen Stempel-Versuch. Der Server liefert im 4xx-Body bereits eine
 * konkrete Erklärung (z. B. „Stempeln nicht möglich – aktueller Status: pause") — die zeigen wir dem Nutzer,
 * statt sie hinter einem pauschalen „anderes Gerät"-Text zu verstecken, der oft schlicht falsch ist.
 * (`ApiError.message` = `body.error` des Servers, siehe api/client.ts.) Fallback nur, wenn keine Server-
 * Erklärung vorliegt (generisches „Fehler <status>") oder es gar kein ApiError ist.
 */
export function stampErrorText(err: unknown): string {
  if (err instanceof ApiError && err.message && !/^Fehler \d+$/.test(err.message)) return err.message
  return 'Anwesenheit hat sich geändert — bitte Stand prüfen und erneut tippen.'
}
